import $ from 'jquery';
import { formatMoney } from '@shopify/theme-currency';
import { register } from './../exports/theme-sections';

const cartSection = {
  onLoad() {
    var $container = $(this.container);
    var ajaxEnabled = $container.attr('data-ajax-enable');
    if (ajaxEnabled == 'true') {
      initQuantity();
      initNotes();
    } else {
      initNoAjax();
    }
  },
};

function initQuantity() {
  $('.js-qty__adjust').off().on('click', function() {
    var $element = $(this);
    loadState($element);
    var newQuantity = parseInt($element.data('new-quantity'), 10);
    var clickedKey = $element.data('line-key');
    changeQuantity(newQuantity, clickedKey);
  });
  $('[data-quantity-input]').off().on('change', function() {
    var $element = $(this);
    loadState($element);
    var newQuantity = parseInt($element.val(), 10);
    var clickedKey = $element.data('line-key');
    changeQuantity(newQuantity, clickedKey);
  });
}
function loadState($element) {
  $element.prop('disabled', true)
    .parents('.js-qty').addClass('qty--disabled')
    .end()
    .siblings()
    .prop('disabled', true);
  $element.closest('.cart__row').find('.item--loadbar').show();
}

function changeQuantity(newQuantity, clickedKey) {
  let oldCount = null;
  let newCount = null;
  let newItem = null;
  window.fetch('/cart.js')
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(response => {
      const matchKeys = (item) => item.key === clickedKey;
      const index = response.items.findIndex(matchKeys);
      oldCount = response.item_count;
      newItem = response.items[index].title;
      const data = {
        line: `${index + 1}`,
        quantity: newQuantity,
      };
      return window.fetch('/cart/change.js', {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data),
      });
    })
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(response => {
      newCount = response.item_count;
      if (oldCount === newCount) {
        stockoutError(newItem);
      } else {
        $('[data-form-errors]').slideUp('fast');
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: {
            cart: response,
          },
          bubbles: true,
        }));
      }
      return window.fetch('/cart?view=ajax');
    })
    .then(handleErrors)
    .then(response => {
      return response.text();
    })
    .then(response => {
      $('[data-cart-form-wrapper]')
        .empty()
        .html(response);
      initQuantity();
      initNotes();
    })
    .catch(e => {
      console.error(e);
      let heading = '';
      if (typeof e.status !== 'undefined') {
        heading = `<p class="strong">${e.status}</p>`;
      }
      let paragraph = e.json.description || '';
      errors(`${heading} ${paragraph}`);
    });
}

function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(function(json) {
      const e = new FetchError({
        status: response.statusText,
        headers: response.headers,
        json: json,
      });
      throw e;
    });
  }
  return response;
}

function FetchError(object) {
  this.status = object.status || null;
  this.headers = object.headers || null;
  this.json = object.json || null;
  this.body = object.body || null;
}
FetchError.prototype = Error.prototype;

function stockoutError(itemTitle) {
  let heading = `<p class="h6--body strong">${window.theme.strings.stockout}</h6>`;
  let paragraph = `<p>${itemTitle}</p>`;
  errors(`${heading} ${paragraph}`);
}

function errors(message) {
  var $errors = $('[data-form-errors]');
  $errors.slideUp('fast');
  $errors
    .empty()
    .html(message)
    .slideDown('fast');
}

function initNotes() {
  var $notes = $('[data-cart-note]');

  $notes.off().on('change', function() {
    var noteValue = $notes.val().toString() || '';
    saveNotes(noteValue);
  });
}

function saveNotes(newNote) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + newNote,
    dataType: 'json',
    error: function(XMLHttpRequest) {
      var $errors = $('[data-form-errors]');
      $errors.slideUp('fast');
      $errors.empty().html(XMLHttpRequest.responseJSON.description).slideDown('fast');
    },
  };
  $.ajax(params);
}

function initNoAjax() {
  $('.js-qty__adjust').off().on('click', function() {
    var $el = $(this);
    var $qtySelector = $el.siblings('.js-qty__num');
    var qty = parseInt($qtySelector.val().replace(/\D/g, ''), 10);

    // Make sure we have a valid integer
    if ((parseFloat(qty) == parseInt(qty, 10)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }

    // Add or subtract from the current quantity
    if ($el.hasClass('js-qty__adjust--plus')) {
      qty++;
    } else {
      qty--;
      if (qty <= 0) { qty = 0; }
    }

    // Update the input's number
    $qtySelector.val(qty).trigger('change');

    $('[data-update]').addClass('cart--dirty');
    $('[data-update]').addClass('heartBeat');
    setTimeout(function() {
      $('[data-update]').removeClass('heartBeat');
    }, 1300);
  });
}

register('cart', cartSection);
